export default __webpack_public_path__ + "static/media/10.75840b34.jpg";